'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var select = require('./select-6c9d108c.js');
var selectItem = require('./select-item-7fd13c43.js');
var selectTitle = require('./select-title-65885e9f.js');
var moment$1 = _interopDefault(require('moment-timezone'));

/* eslint-disable max-lines-per-function */
function formatDuration(durationInMinutes, hourText, minuteText) {
    var hours = Math.floor(durationInMinutes / 60);
    var minutes = durationInMinutes % 60;
    var format = [];
    if (hours > 0) {
        format.push(hours + " " + (hourText || 'hr'));
    }
    if (minutes > 0) {
        format.push(minutes + " " + (minuteText || 'min'));
    }
    return format.join(', ');
}
var getTimeWithDurationDisplayLabel = function (date, bookingStartDate, timezone, hourText, minuteText) {
    var endDate = moment$1(date);
    var durationInMinutes = Math.round(moment$1.duration(endDate.diff(moment$1(bookingStartDate))).asMinutes());
    return endDate.tz(timezone).format('LT') + " (" + formatDuration(durationInMinutes, hourText, minuteText) + ")";
};
var getTimeDisplayLabel = function (date, timezone) { return moment$1(date).tz(timezone).format('LT'); };
var TimeSelect = function (_a) {
    var className = _a.className, dataCy = _a.dataCy, dataTestId = _a.dataTestId, disabled = _a.disabled, errored = _a.errored, placeholder = _a.placeholder, title = _a.title, required = _a.required, options = _a.options, dateValue = _a.dateValue, showDuration = _a.showDuration, durationStartDate = _a.durationStartDate, hourText = _a.hourText, minuteText = _a.minuteText, _b = _a.timezone, timezone = _b === void 0 ? constants.DEFAULT_TIME_ZONE : _b, handleChange = _a.handleChange;
    var onChange = React.useCallback(function (e) { return handleChange(new Date(e.target.value)); }, [handleChange]);
    return (React__default.createElement(select.Select, { className: className, "data-cy": dataCy, "data-testid": dataTestId, value: dateValue instanceof Date
            ? dateValue.toISOString() : '', selectedValueLabel: dateValue
            ? moment$1.tz(dateValue, timezone).format('LT')
            : '', onChange: onChange, required: required, errored: errored, disabled: disabled, titleComponent: React__default.createElement(selectTitle.SelectTitle, { title: title }), placeholder: placeholder || 'Select' }, options === null || options === void 0 ? void 0 : options.map(function (option) {
        var timeDisplayLabel = showDuration
            ? getTimeWithDurationDisplayLabel(option, durationStartDate, timezone, hourText, minuteText)
            : getTimeDisplayLabel(option, timezone);
        return (React__default.createElement(selectItem.SelectItem, { key: option.toISOString(), value: option.toISOString(), renderedValue: timeDisplayLabel }));
    })));
};

exports.TimeSelect = TimeSelect;
